import { Description, Text, Token } from '@revolut-internal/ui-kit'
import { FC, Fragment } from 'react'
import styled from 'styled-components'

import { Markdown } from 'components'

import { renderParamValue } from './renderParamValue'

const StyledBox = styled.div`
  overflow-wrap: break-word;
  padding: 11px 12px;
  border-bottom: 1px ${Token.color.greyTone5} solid;
`

const Heading = styled(Description)`
  font-weight: 500;
`

const StyledGrid = styled.div`
  overflow: hidden;
  background-color: ${Token.color.background};
  display: grid;
  grid-template-columns: minmax(0, auto) minmax(0, 1fr);
  border-radius: ${Token.radius.widget};
  max-width: 100%;
  border: 1px ${Token.color.greyTone5} solid;

  ${StyledBox}:nth-child(-n+2) {
    background-color: ${Token.color.greyTone5};
  }

  ${StyledBox}:nth-last-child(-n+2) {
    border-bottom: none;
  }

  ${StyledBox}:nth-child(odd) {
    border-right: 1px ${Token.color.greyTone5} solid;
  }
`

type Props = {
  data: Record<string, unknown>
  markdown?: boolean
  chatUiRenderMethod?: boolean
}

export const ParamsTable: FC<Props> = props => {
  const { data, markdown = false, chatUiRenderMethod = false } = props

  const entries = Object.entries(data)

  if (!entries.length) {
    return <Text color="grey-tone-20">–</Text>
  }

  return (
    <StyledGrid>
      <StyledBox>
        <Heading variant="small">Key</Heading>
      </StyledBox>
      <StyledBox>
        <Heading variant="small">Value</Heading>
      </StyledBox>
      {entries.map(([key, value]) => (
        <Fragment key={key}>
          <StyledBox>
            <Description variant="small">{key}</Description>
          </StyledBox>
          <StyledBox>
            <Description variant="small" textOverflow="overflow">
              {markdown ? (
                <Markdown chatUiRenderMethod={chatUiRenderMethod}>{value}</Markdown>
              ) : (
                renderParamValue(value)
              )}
            </Description>
          </StyledBox>
        </Fragment>
      ))}
    </StyledGrid>
  )
}
